import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {HttpError} from '@specials/project-user';

import {LoggerService} from '@/services/LoggerService/LoggerService';
import {IProjectApi} from '@/services/ProjectApi/types';
import {TrackingService} from '@/services/TrackingService/TrackingService';
import {AnalyticsNotificationsStateType} from '@/services/TrackingService/constants';
import {UserStore} from '@/stores/UserStores/UserStore';

export class SubscriptionChangeUseCase {
  constructor(
    private readonly projectApi: IProjectApi,
    private readonly userStore: UserStore,
    private readonly loggerService: LoggerService,
    private readonly trackingService: TrackingService,
  ) {}

  public changeIsSubscribedToNotification = async (): Promise<void> => {
    if (this.userStore.isProcessing()) {
      return;
    }

    this.userStore.toProcessing();
    const newIsSubscribedToNotification = !this.userStore.getUserIsSubscribedToNotifications();

    try {
      await this.projectApi.updateIsSubscribedToNotifications({
        isSubscribedToNotifications: newIsSubscribedToNotification,
      });
      this.userStore.setIsSubscribedToNotificationsSuccess(newIsSubscribedToNotification);
      const analyticsValue = newIsSubscribedToNotification
        ? AnalyticsNotificationsStateType.On
        : AnalyticsNotificationsStateType.Off;
      this.trackingService.trackClickOnNotificationsSwitchButton(analyticsValue);
    } catch (error: unknown) {
      this.userStore.toError(error as HttpError);
      this.loggerService.logHttpError(error as HttpError);
      // пробрасываем ошибку, чтобы обработать поведение в компоненте
      throw error;
    }
  };
}

injected(
  SubscriptionChangeUseCase,
  DI_TOKENS.projectApi,
  DI_TOKENS.userStore,
  DI_TOKENS.loggerService,
  DI_TOKENS.trackingService,
);
